import { createClient as baseCreateClient, type Route } from '@prismicio/client'
import { type CreateClientConfig, enableAutoPreviews } from '@prismicio/next/pages'
import sm from '../slicemachine.config.json'

/**
 * The project's Prismic repository name.
 */
export const { repositoryName } = sm

/**
 * A list of Route Resolver objects that define how a document's `url` field is resolved.
 *
 * {@link https://prismic.io/docs/route-resolver#route-resolver}
 */
// TODO: Add routes here
const routes: Route[] = [
	{ type: 'home', path: '/' },
	{ type: 'home_rebrand', path: '/' },
	{ type: 'page', path: '/:uid' },
	{ type: 'page_rebrand', path: '/:uid' },
	{ type: 'article', path: '/magazine/article/:uid' },
	{ type: 'magazine', path: '/magazine' },
	{ type: 'members_market', path: '/members-market' },
	{ type: 'subscription_listing', path: '/subscriptions' },
	{ type: 'subscription_detail', path: '/subscriptions/:uid' },
	{ type: 'survey_questions', path: '/survey/:uid' },
	{ type: 'sms_landing_page', path: '/sms/:uid' },
	{ type: 'test', path: '/test/:uid' }
]

/**
 * Creates a Prismic client for the project's repository. The client is used to
 * query content from the Prismic API.
 *
 * @param config - Configuration for the Prismic client.
 */
export const createClient = ({ previewData, req, ...config }: CreateClientConfig) => {
	const client = baseCreateClient(repositoryName, {
		// routes,
		...config
	})

	enableAutoPreviews({ client, previewData, req })

	return client
}
